<!--Navbar-->
<app-navbar></app-navbar>

<div class="w-full h-screen">
  <div class="lottie-animation w-[100%] h-[80%] mx-auto mt-[135px]">
   <img src="/assets/images/404.png" class="object-contain h-4/5 w-full">
    <div class="text-center">      
      <button type="button" (click)="homeButton()" class="text-white relative bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 px-20 focus:ring-gray-300 font-medium rounded-full text-sm pl-[2.25rem] pr-[3.25rem] py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">
        <mat-icon aria-hidden="false" class="absolute left-[5rem] top-[8px]" aria-label="home icon" fontIcon="home"></mat-icon>
         Home</button>

     
    </div>
  </div>
  
</div>

<!-- Footer  -->
<app-message></app-message>
<app-footer></app-footer>